import { Component } from 'react';

export class CheckShieldSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="20"
                viewBox="0 0 19 20"
            >
                <g fill="none" fillRule="evenodd">
                    <path
                        fill="#0D9876"
                        fillRule="nonzero"
                        d="M9.32 0L.34 2.936v4.998c0 5.554 3.663 10.434 8.98 11.941 5.318-1.507 8.982-6.387 8.982-11.94v-5L9.32 0z"
                    />
                    <path
                        fill="#FFF"
                        d="M13.187 7.913a.465.465 0 0 1-.14.341l-4.32 4.32a.465.465 0 0 1-.34.14.465.465 0 0 1-.342-.14l-2.502-2.501a.465.465 0 0 1-.14-.342c0-.134.047-.248.14-.341l.684-.684a.465.465 0 0 1 .341-.14c.134 0 .248.047.342.14l1.476 1.482 3.295-3.3a.465.465 0 0 1 .341-.14c.134 0 .248.047.342.14l.683.683c.094.094.14.208.14.342z"
                    />
                </g>
            </svg>
        );
    }
}
